import sanitizeHtml from 'sanitize-html';

export const sanitizeCommentText = (text) => {
  text = sanitizeHtml(text, {
    allowedTags: ['span', 'br'],
    allowedAttributes: {
      span: ['data-id'],
    },
    allowedClasses: {
      span: ['tag'],
    },
    parser: {
      lowerCaseTags: true,
    },
  });
  text = text.replace(/<br \/>/g, '\n').trim();
  return text;
};

export const prepareCommentForDisplay = (text) => {
  return sanitizeCommentText(text).replace(
    /(https?:\/\/www\.|https?:\/\/|www\.)([-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\/(([-a-zA-Z0-9()@:;%_+.~#&/=]*)\/)*([-a-zA-Z0-9()@:;%_+.~#&=]+)|([-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}))([-a-zA-Z0-9()@:;%_+.~#?&/=]*)?/gi,
    '<a target="_blank" href="$&">$6$5</a>'
  );
};



// WEBPACK FOOTER //
// ./src/common/htmlHelper.js